import { Skeleton, Stack } from '@sixui/ui';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type ISidebarSectionItemSkeletonProps = IContainerProps;

const styles = stylex.create({
  host: {
    height: 56,
    paddingLeft: 20,
  },
  icon: {
    width: 24,
    height: 24,
    marginRight: 8,
  },
});

export const SidebarSectionItemSkeleton: React.FC = () => (
  <Stack horizontal sx={styles.host}>
    <Skeleton sx={styles.icon} />
    <Skeleton
      length={{
        min: 8,
        max: 16,
      }}
    />
  </Stack>
);
